import styled, { AnyStyledComponent } from 'styled-components';
import { BreakpointsType } from '../../../style/breakpoints';

function getWidthString(span: number) {
  if (!span) return;
  return `width: ${span}%`;
}

interface StyledGridItemProps {
  verticalGutter: number;
  horizontalGutter: number;
  xs?: number;
  sm?: number;
  md?: number;
  lg?: number;
  xl?: number;
  xsHidden: boolean;
  smHidden: boolean;
  mdHidden: boolean;
  lgHidden: boolean;
  xlHidden: boolean;
  breakpoints: BreakpointsType;
}

// Provide all the breakpoints and hiding styling for each
// of the grid items.
export const GridItemWrapper: AnyStyledComponent = styled.div`
  box-sizing: border-box;
  ${({verticalGutter, horizontalGutter, xs, sm,
    md, lg, xl, xsHidden, smHidden, mdHidden,
    lgHidden, xlHidden, breakpoints}: StyledGridItemProps) => `
      width: 100%;
      padding: ${verticalGutter / 2}px ${horizontalGutter / 2}px;
  
      ${xs ? getWidthString(xs) : ''};
      display: ${xsHidden ? 'none' : 'inline-block'};
  
      @media only screen and (min-width: ${breakpoints.sm}) {
        ${sm ? getWidthString(sm) : ''};
        display: ${smHidden ? 'none' : 'inline-block'};
      }
  
      @media only screen and (min-width: ${breakpoints.md}) {
        ${md ? getWidthString(md) : ''};
        display: ${mdHidden ? 'none' : 'inline-block'};
      }
  
      @media only screen and (min-width: ${breakpoints.lg}) {
        ${lg ? getWidthString(lg) : ''};
        display: ${lgHidden ? 'none' : 'inline-block'};
      }
  
      @media only screen and (min-width: ${breakpoints.xl}) {
        ${xl ? getWidthString(xl) : ''};
        display: ${xlHidden ? 'none' : 'inline-block'};
      }
  `}
`;
